import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import Filter from './filter';
import SearchForm from './SearchForm';
import ListHeader from 'components/ListHeader';
import Pagination from 'components/Pagination';

import { dspState } from 'atoms/DspState';
import { warehouseState } from 'atoms/WarehouseState';
import { warehouseFilterState } from 'atoms/WarehouseFilterState';

import * as Constants from '../constants';
import { processType } from './../helpers';

import { listDsp } from 'repositories/HttpRepository';

const fields = [
  { id: 'id', numeric: false, disablePadding: true, label: 'id' },
  {
    id: 'alias',
    numeric: false,
    disablePadding: false,
    label: 'Warehouse Alias',
  },
  {
    id: 'address',
    numeric: false,
    disablePadding: false,
    isDisableSort: true,
    label: 'Adress',
  },
  { id: 'region', numeric: false, disablePadding: false, label: 'Region' },
  { id: 'owner_type', numeric: false, disablePadding: false, label: 'Type' },
];

const useStyles = makeStyles()((theme) => ({
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
    backgroundColor: '#fff',
  },
  table: {
    minWidth: 750,
  },
}));

function ListWarehouse() {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const warehouses = useRecoilValue(warehouseState);
  const [dspList, setDspList] = useRecoilState(dspState);
  const [filterStates, setFilterState] = useRecoilState(warehouseFilterState);

  const { items, total, size } = warehouses;
  const { is_desc, order_by } = filterStates.sort;

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && is_desc;
    setFilterState({
      ...filterStates,
      sort: {
        ...filterStates.sort,
        is_desc: !isDesc,
        order_by: property,
      },
    });
  };

  function handleSearch(keyword) {
    setFilterState((previous) => ({
      ...previous,
      selected: { ...previous.selected, q: keyword, page: 0 },
    }));
  }

  function handeSearchReset(e) {
    setFilterState((previous) => ({
      ...previous,
      selected: { ...previous.selected, q: null, page: 0 },
    }));
  }

  const viewDetail = (id) => {
    navigate('/warehouses/' + id);
  };

  function handleChangePagination(e, page) {
    setFilterState((previous) => ({
      ...previous,
      selected: { ...previous.selected, page: page - 1 },
    }));
  }

  useEffect(() => {
    const params = { order_by: 'id', desc: false, size: 999 };
    listDsp(params)
      .then((response) => {
        if (response.ok) setDspList(response.data);
      })
      .catch((err) => toast.error(err));
  }, []);

  return (
    <Container maxWidth={false}>
      <Filter dspList={dspList} />
      <SearchForm onSubmit={handleSearch} reset={handeSearchReset} />

      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader
              fields={fields}
              desc={filterStates.sort.is_desc}
              orderBy={filterStates.sort.order_by}
              onRequestOrder={handleRequestSort}
              rowCount="1"
            />
            <TableBody>
              {items.map((item, index) => {
                const labelId = `dsp-table-item-${index}`;
                let currentDSP = {};
                if (item.owner_type === Constants.OWNER_TYPE_COURIER_STR) {
                  currentDSP = dspList?.items?.find((dsp) => dsp.id === item.owner_id);
                }

                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={`warehouse-${item.id}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => viewDetail(item.id)}
                  >
                    <TableCell component="th" id={labelId} scope="row">
                      {item.id}
                    </TableCell>
                    <TableCell>{item.alias}</TableCell>
                    <TableCell>{item.address.street}</TableCell>
                    <TableCell>{item.region}</TableCell>
                    <TableCell>
                      {processType(item.owner_type, item.client_name ?? currentDSP?.code ?? currentDSP?.company)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          total={total}
          size={size}
          forceUpdatePage={filterStates.selected.page == null ? 0 : filterStates.selected.page}
          onChange={handleChangePagination}
        />
      </Paper>
    </Container>
  );
}

export default ListWarehouse;
